export default __webpack_public_path__ + "static/media/dina.60a7cf11.jpg";